import { inject, Pipe, type PipeTransform } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { AddressState } from 'src/app/interface/state';
import { AddressService } from 'src/app/service/address.service';
import { ObjectId } from 't5-common';

@Pipe({
  name: 'mkgFindState',
  standalone: true,
  pure: true
})
export class FindStatePipe implements PipeTransform {

  private _addressService = inject(AddressService);

  transform(id: ObjectId): Observable<AddressState> {
    if(!id){
      return of(null);
    }
    return this._addressService.findState(id).pipe(
      shareReplay(1)
    );
  }

}
